var map = {
	"./CAT.json": [
		1435,
		435
	],
	"./ENG.json": [
		2974,
		974
	],
	"./ESP.json": [
		594,
		594
	],
	"./FRA.json": [
		6202,
		202
	],
	"./POL.json": [
		6164,
		164
	],
	"./SLV.json": [
		7515,
		515
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5774;
module.exports = webpackAsyncContext;